import { create } from 'zustand';
import { 
	redux, 
	// devtools 
} from 'zustand/middleware';

export enum IUserActions {
	SET_ENLARGED_IMG_ID = 'SET_ENLARGED_IMG_ID',
	SET_ENLARGED_VIDEO = 'SET_ENLARGED_VIDEO',
	SET_IMG_TRK_START_SCENE = 'SET_IMG_TRK_START_SCENE',
	SET_PLACEMENT_MODE_UI_VISIBLE = 'SET_PLACEMENT_MODE_UI_VISIBLE',
	SET_FACE_TRACKING_VISIBLE = 'SET_FACE_TRACKING_VISIBLE',
	SET_TRACKING_IMAGE_VISIBLE = 'SET_TRACKING_IMAGE_VISIBLE',
	SET_SNAPSHOT_UI_VISIBLE = 'SET_SNAPSHOT_UI_VISIBLE',
	SET_LINK_SCENE_ENABLED_IMAGE_TRACKER_ID = 'SET_LINK_SCENE_ENABLED_IMAGE_TRACKER_ID',
	SET_ENABLED_IMAGE_TRACKER_IDS = 'SET_ENABLED_IMAGE_TRACKER_IDS',
	SET_GRAB_N_GO_ENABLED = 'SET_GRAB_N_GO_ENABLED',
	SET_GRAB_N_GO_ACTIVE = 'SET_GRAB_N_GO_ACTIVE',
	SET_ROUND_ROBIN_ACTIVE = 'SET_ROUND_ROBIN_ACTIVE'
}

interface IUserActionObj {
	type: IUserActions;
	payload: any; // TODO make type safe
}

type IUserState = {
	enlargedImgId?: string;
	inSceneVideoRef?: HTMLVideoElement;
	enlargedVideoId?: string;
	placementModeUiVisible: boolean;
	isFaceTrackingVisible: boolean;
	isTrackingImageVisible: boolean;
	isSnapshotUiVisible: boolean;
	isGrabNGoEnabled: boolean;
	isGrabNGoActive: boolean;
	isRoundRobinActive: boolean;
	linkSceneEnabledImageTrackerId: string | null;
	enabledImageTrackerIds: string[];
	imageTrackerStartScenes: {[id: string]: string};
	dispatch?: (args: IUserActionObj) => IUserActionObj;
};

const initialState: IUserState = {
	placementModeUiVisible: true,
	isFaceTrackingVisible: false,
	isTrackingImageVisible: true,
	isSnapshotUiVisible: false,
	isGrabNGoEnabled: false,
	isGrabNGoActive: false,
	isRoundRobinActive: false,
	linkSceneEnabledImageTrackerId: null,
	enabledImageTrackerIds: [],
	imageTrackerStartScenes: {}
};

const reducer = (state: IUserState, { type, payload }: IUserActionObj) => {
	switch (type) {
		case IUserActions.SET_LINK_SCENE_ENABLED_IMAGE_TRACKER_ID:
			return { ...state, linkSceneEnabledImageTrackerId: payload };
		case IUserActions.SET_IMG_TRK_START_SCENE:
			return { ...state, imageTrackerStartScenes: {...state.imageTrackerStartScenes, ...payload}};
		case IUserActions.SET_ENABLED_IMAGE_TRACKER_IDS:
			return { ...state, enabledImageTrackerIds: payload };
		case IUserActions.SET_ROUND_ROBIN_ACTIVE:
			return { ...state, isRoundRobinActive: payload };
		case IUserActions.SET_ENLARGED_IMG_ID:
			return { ...state, enlargedImgId: payload };
		case IUserActions.SET_FACE_TRACKING_VISIBLE:
			return {
				...state,
				isFaceTrackingVisible: payload.isFaceTrackingVisible,
			};
		case IUserActions.SET_TRACKING_IMAGE_VISIBLE: {
			return { ...state, isTrackingImageVisible: payload.visible };
		}
		case IUserActions.SET_PLACEMENT_MODE_UI_VISIBLE:
			return { ...state, placementModeUiVisible: payload };
		case IUserActions.SET_SNAPSHOT_UI_VISIBLE:
			return { ...state, isSnapshotUiVisible: payload };
		case IUserActions.SET_GRAB_N_GO_ENABLED:
			return { ...state, isGrabNGoEnabled: payload };
		case IUserActions.SET_GRAB_N_GO_ACTIVE:
			return { ...state, isGrabNGoActive: payload };
		case IUserActions.SET_ENLARGED_VIDEO:
			return {
				...state,
				inSceneVideoRef: payload.videoRef,
				enlargedVideoId: payload.id,
			};
		default:
			return state;
	}
};

export const useUserStore = create(redux(reducer, initialState));
// export const useUserStore = create(devtools(redux(reducer, initialState)));
